export const itemMixin = {
  data () {
    return {
      active: false,
      childActive: false,
      itemShow: false
    }
  },
  created () {
    this.initActiveState()
    this.initShowState()

    if (!this.$router) {
      window.addEventListener('hashchange', () => {
        this.initActiveState()
      })
    }
  },
  methods: {
    isLinkActive (item) {
      return this.matchRoute(item.href) || this.isAliasActive(item)
    },
    isChildActive (child) {
      return child.some(item => {
        return this.isLinkActive(item) || (item.child ? this.isChildActive(item.child) : false)
      })
    },
    isAliasActive (item) {
      if (item.alias) {
        if (Array.isArray(item.alias)) {
          return item.alias.some(alias => {
            return this.matchRoute(alias)
          })
        } else {
          return this.matchRoute(item.alias)
        }
      }
      return false
    },
    matchRoute (route) {
      if (this.$route) {
        return route === this.$route.fullPath
      } else {
        return route === window.location.pathname + window.location.search + window.location.hash
      }
    },
    clickEvent (event) {
      this.emitItemClick(event, this.item)

      if ((!this.item.href && (!this.item.child || this.mobileItem)) || this.item.disabled) {
        event.preventDefault()
        return
      }

      if (!this.mobileItem && this.isCollapsed && this.firstItem) {
        let clearCloseTimeout = this.item.child
        this.$parent.$emit('touchClickItem', clearCloseTimeout)
      }

      let showOneChildEnabled = this.firstItem && this.showOneChild && !this.showChild
      if (!this.mobileItem && this.item.child) {
        if (!this.item.href) {
          event.preventDefault()
        }
        if (showOneChildEnabled) {
          this.activeShow === this._uid ? this.setActiveShow(false) : this.setActiveShow(true, this._uid)
        } else {
          this.itemShow = !this.itemShow
          // 하위메뉴도 하나 펼치면 다 접히도록
          if (this.itemShow) {
            this.$_.forEach(this.$parent.$children, item => {
              if (this._uid !== item._uid) {
                item.itemShow = false
              }
            });
          }
        }
      } else if (!this.mobileItem && showOneChildEnabled) {
        this.emitActiveShow(null)
      }
    },
    movePageOpenList() {
      let showOneChildEnabled = this.firstItem && this.showOneChild && !this.showChild
      if (!this.mobileItem && this.item.child) {
        if (showOneChildEnabled) {
          this.activeShow === this._uid ? null : this.setActiveShow(true, this._uid)
        } else {
          this.itemShow = true
        }
      } else if (!this.mobileItem && showOneChildEnabled) {
        this.emitActiveShow(null)
      }
    },
    setActiveShow (itemShow, uid = null) {
      this.emitActiveShow(itemShow ? uid : null)
      this.itemShow = itemShow
    },
    initActiveState () {
      this.active = this.item && this.item.href ? this.isLinkActive(this.item) : false
      this.childActive = this.item && this.item.child ? this.isChildActive(this.item.child) : false
      if (this.childActive) {
        this.movePageOpenList();
      }
    },
    initShowState () {
      if (this.item && this.item.child) {
        this.itemShow = this.isLinkActive(this.item) || this.isChildActive(this.item.child)
        if (this.showOneChild && !this.showChild && this.firstItem && (this.active || this.childActive)) {
          this.emitActiveShow(this._uid)
        }
      }
    }
  },
  computed: {
    isRouterLink () {
      return this.$router && this.item && this.item.href
    },
    show () {
      if (!this.item || !this.item.child) return false
      if (this.showChild) return this.showChild
      if (this.firstItem && this.showOneChild) {
        return this._uid === this.activeShow
      } else {
        return this.mobileItem ? true : this.itemShow
      }
    }
  },
  watch: {
    $route () {
      this.initActiveState()
    }
  },
  inject: ['emitActiveShow', 'emitItemClick']
}

export const animationMixin = {
  methods: {
    expandEnter (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    expandAfterEnter (el) {
      el.style.height = 'auto'
    },
    expandBeforeLeave (el) {
      if (this.isCollapsed) {
        el.style.display = 'none'
        return
      }
      el.style.height = el.scrollHeight + 'px'
    }
  }
}
